export const Symbols = {
    // copy from common
    BoHttp: Symbol.for('BoHttp'),
    CompanyService: Symbol.for('CompanyService'),
    // spec
    CooperativeCompanyServiceUrls: Symbol.for('CooperativeCompanyServiceUrls'),
    CooperativeCompanyService: Symbol.for('CooperativeCompanyService'),
};
